import { AxiosResponse } from 'axios';
import queryString from 'query-string';

import { PaginationMetaOptionsType } from 'components/shared/types';
import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';
import { decamelizeKeys } from 'utils/humps';
import { IPage } from 'utils/types';

import { getAccountId } from './auth';

const decoratedAxiosGet = axiosGetAutoCancelDecorator();

type GetMatserPropertiesResponse = {
  data: IPage;
  meta: PaginationMetaOptionsType;
};

type Props = {
  search?: string;
  limit?: number;
};

export const getMasterProperties = async ({ search, limit = 100 }: Props): Promise<GetMatserPropertiesResponse> => {
  const query = queryString.stringify(
    decamelizeKeys({
      q: search,
      limit,
      masterProperties: true,
      orderBy: 'handle',
      countless: '1',
    }),
    {
      skipNull: true,
      skipEmptyString: true,
    },
  );

  const response = (await decoratedAxiosGet(
    `/acc/${getAccountId()}/pages/dropdown?${query}`,
  )) as AxiosResponse<GetMatserPropertiesResponse>;

  return response.data;
};
